<div fxFlexFill *ngIf="soapItems && soapItems.length > 0" class="bres-panel bres-panel-info">
  <div class="bres-panel-content">
    <div class="bres-panel-title"><i class="k-icon k-i-dictionary-add"></i>&nbsp;Select SOAP Items</div>
    <div class="bres-panel-body">
      <app-select-soap-notes [encounter]="encounter"></app-select-soap-notes>
    </div>
  </div>
</div>

<div fxFlexFill *ngIf="!soapItems || (soapItems && soapItems.length === 0)" fxLayoutAlign="center center">
  <div fxFlex fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="center center" class="bres-panel-blank bres-panel-blank-secondary">
    <span>No SOAP items reported for this patient</span>
  </div>
</div>
